import { useMemo } from 'react';
import { useAddTicketsToCartStore } from '../../../stores';
import { getAddToCartItemByPackageId, getEventDateItemsFromItems } from '../../../stores/add-to-cart-stores/models/add-to-cart-items';
import { useAddPackageToCartStoreExt } from '../../../stores/add-to-cart-stores/add-package-to-cart-store-ext';

export function useSelectedItems() {
    const isAPackageSale = useAddPackageToCartStoreExt(s => s.isAPackageSale);
    const [packageItems, packageId] = useAddPackageToCartStoreExt(s => [s.packageItems, s.packageId]);
    const [eventDateItems, eventDateId] = useAddTicketsToCartStore(s => [s.eventDateItems, s.eventDateId]);

    const selectedItems = useMemo(() => {
        if (!isAPackageSale()) {
            return getEventDateItemsFromItems(eventDateItems, eventDateId);
        } else {
            return getAddToCartItemByPackageId(packageItems, packageId);
        }
    }, [isAPackageSale, eventDateItems, packageId, packageItems, eventDateId]);

    return selectedItems;
}

// export function useEventDateItems(eventDateId: number) {
//     const eventDateItems = useAddTicketsToCartStore(s => s.eventDateItems);
//     return useMemo(() => getEventDateItemsFromItems(eventDateItems, eventDateId), [eventDateId, eventDateItems]);
// }

